import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import dieGroupService from '../services/die-group.service';
import { setMessage } from './message';
export const fetchDieGroupList = createAsyncThunk(
  'dieGroup/fetchDieGroupList',
  async ({ page, pagesize, search, ordering }, thunkAPI) => {
    try {
      const response = await dieGroupService.getDieGroupList(page, pagesize, search, ordering);

      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);
export const fetchDieGroupDropdown = createAsyncThunk(
  'dieGroup/fetchDieGroupDropdown',
  async ({ page, pagesize, search, ordering }, thunkAPI) => {
    try {
      const response = await dieGroupService.getDieGroupList(page, pagesize, search, ordering);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);
export const fetchArchivedDieGroupList = createAsyncThunk(
  'dieGroup/fetchArchivedDieGroupList',
  async ({ page, pagesize, search, ordering }, thunkAPI) => {
    try {
      const response = await dieGroupService.getDieArchiveGroupList(
        page,
        pagesize,
        search,
        ordering,
      );
      return response.data; // Assuming response contains { data, count, totalPages, etc. }
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const createDieGroup = createAsyncThunk(
  'dieGroup/createDieGroup',
  async (categoryData, thunkAPI) => {
    try {
      const response = await dieGroupService.addDieGroup(
        categoryData.name,
        categoryData.description,
      );
      return response.data; // Assuming response contains the created die group data
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const updateDieGroup = createAsyncThunk(
  'dieGroup/updateDieGroup',
  async ({ id, values }, thunkAPI) => {
    try {
      const response = await dieGroupService.updateDieGroup(id, values);
      thunkAPI.dispatch(fetchDieGroupList({ page: 1, limit: 10 })); // Re-fetch list after update
      return response.data; // Return the updated die group data
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const deleteDieGroup = createAsyncThunk(
  'dieGroup/deleteDieGroup',
  async (id, thunkAPI) => {
    try {
      await dieGroupService.deleteDieGroup(id); // Ensure `id` is used here
      return id; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const unArchiveDieGroup = createAsyncThunk(
  'dieGroup/unArchiveDieGroup',
  async (id, thunkAPI) => {
    try {
      await dieGroupService.unArchiveDieGroup(id); // Ensure `id` is used here
      return id; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

const initialState = {
  data: [],
  list: [],
  loading: false,
  totalpage: 0,
  totaldie: 0,
  currentpage: 1,
  totalRecord: 0,
  status: 'idle',
  error: null,
  hasMore: true,
};

const dieGroupSlice = createSlice({
  name: 'dieGroup',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    resetDieGroupList: state => {
      state.list = [];
    },
    resetCurrentGroupPage: state => {
      state.currentpage = 1;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchDieGroupList.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchDieGroupList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentpage;
        state.data = action.payload.results.data || []; // Adjust this to match your API response
        state.totalRecord = action.payload.count || 0;
        state.totalpage = action.payload.totalPages || 0;
        state.totaldie = action?.payload?.results?.total_die_count || 0;
        state.currentpage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchDieGroupList.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchDieGroupDropdown.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchDieGroupDropdown.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentpage;
        state.data = action.payload.results.data || []; // Adjust this to match your API response
        state.totalRecord = action.payload.count || 0;
        state.totalpage = action.payload.totalPages || 0;
        state.currentpage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchDieGroupDropdown.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchArchivedDieGroupList.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchArchivedDieGroupList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentpage;
        state.data = action.payload.results.data || []; // Adjust this to match your API response
        state.totalRecord = action.payload.count || 0;
        state.totalpage = action.payload.totalPages || 0;
        state.currentpage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchArchivedDieGroupList.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(createDieGroup.pending, state => {
        state.status = 'loading';
      })
      .addCase(createDieGroup.fulfilled, (state, action) => {
        state.status = 'succeeded';
      })
      .addCase(createDieGroup.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
    builder
      .addCase(updateDieGroup.pending, state => {
        state.status = 'loading';
      })
      .addCase(updateDieGroup.fulfilled, (state, action) => {
        state.status = 'succeeded';
      })
      .addCase(updateDieGroup.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(deleteDieGroup.pending, state => {
        state.status = 'loading';
      })
      .addCase(deleteDieGroup.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
        state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
      })
      .addCase(deleteDieGroup.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(unArchiveDieGroup.pending, state => {
        state.status = 'loading';
      })
      .addCase(unArchiveDieGroup.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
      })
      .addCase(unArchiveDieGroup.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { resetDieGroupList, resetCurrentGroupPage } = dieGroupSlice.actions;
const { reducer } = dieGroupSlice;
export default reducer;
